export default __webpack_public_path__ + "static/media/rt-ht.469718f3.svg";